import FieldDate from "../../../generic/datetime/date/date"
import FieldConfig from "../../../proto/field-config"

export default class FieldTimeReportDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config)

        this.label              = "Report date"
        this.description        = "Date of Time Report"

        const reportingLimit    = gd.ac.check.company.isManager() ? gd.company.settings.labs.timeReport.reportingLimitManager : gd.company.settings.labs.timeReport.reportingLimit
        const reportingDays     = gd.ac.check.company.isManager() ? gd.company.settings.labs.timeReport.reportingDaysManager : gd.company.settings.labs.timeReport.reportingDays

        this.minDate            = reportingLimit ? moment().subtract(reportingDays,'days') : undefined
        this.maxDate            = moment()  // cant report for the future
        this.clearButton        = false     // field is required
    }
}